export const SUCCESS_MODAL_HEIGHT = 561;
export const USUAL_MODAL_HEIGHT = 628;
export const USUAL_MODAL_TITLE = 'Аналитический отчёт по зданию';
